import GenericRoutes from "./Routes";
import { AuthProvider } from "./lib/context/Auth/AuthContext";
import { NavbarProvider } from "./lib/context/NavBar/navbarContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const APP_VERSION = "1.0.19";

  const clearOldVersionCookies = () => {
    const versionCookie = document.cookie
      .split(";")
      .find((cookie) => cookie.trim().startsWith("app_version="));

    const currentVersion = versionCookie ? versionCookie.split("=")[1] : null;

    if (currentVersion === APP_VERSION) return;

    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
      const [name] = cookie.split("=").map((c) => c.trim());
      if (name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });

    document.cookie = `app_version=${APP_VERSION}; path=/; max-age=31536000`;
  };

  clearOldVersionCookies();
  return (
    <AuthProvider>
      <NavbarProvider>
        <GenericRoutes />
        <ToastContainer />
      </NavbarProvider>
    </AuthProvider>
  );
}

export default App;
